import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';

interface Profile {
  id: string;
  email: string;
  display_name?: string;
  date_of_birth?: string;
  sex?: string;
  units_preference?: 'metric' | 'imperial';
  created_at: string;
}

export function useProfile() {
  return useQuery<{ profile: Profile }>({
    queryKey: ['mr-profile'],
    queryFn: () => api.get('/profile'),
  });
}

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) =>
      api.put<{ profile: Profile }>('/profile', data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mr-profile'] });
    },
  });
}
